import { DropDownModel } from "./dropDown";
import { ValidatedValue } from "./validator";

export interface PolicyResponseModel {
    policyId: number;
    policyNumber: string;
    pdfToken: string;
}

export const DefaultPolicyResponse: PolicyResponseModel = {
    policyId: 0,
    policyNumber: "",
    pdfToken: ""
};

export interface PolicyRenewalData {
    series: string;
    number: ValidatedValue<string>;
    peselOrRegon: ValidatedValue<string>;
}

export enum PolicyRenewalSeries {
    DMS = "DMS",
    HFS = "HFS",
    WDM = "WDM",
    DMN = "DMN"
}

export const PolicyRenewalSeriesDropDown: DropDownModel[] = [
    {
        id: PolicyRenewalSeries.DMS,
        displayName: PolicyRenewalSeries.DMS
    },
    {
        id: PolicyRenewalSeries.HFS,
        displayName: PolicyRenewalSeries.HFS
    },
    {
        id: PolicyRenewalSeries.WDM,
        displayName: PolicyRenewalSeries.WDM
    },
    {
        id: PolicyRenewalSeries.DMN,
        displayName: PolicyRenewalSeries.DMN
    }
];
